module.exports = __webpack_public_path__ + "media/file-icons/word-bd226cda.gif";